import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { ToastrModule } from 'ngx-toastr';
import { NumToRomanPipe } from '../shared/components/tabs/pipes/num-to-roman.pipe';
import { MyDatePipe } from '../shared/pipes/date-translate/date-translate.pipe';
import { PhonePipe } from '../shared/pipes/phone/phone.pipe';
import { UtcToLocalPipe } from '../shared/pipes/utc-to-local/utc-to-local.pipe';
import { AutorizationGuard } from './guards/authorization/autorization.guard';
import { AuthorizedGuard } from './guards/authorized/authorized.guard';

@NgModule({
  imports: [
    CommonModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-center',
      closeButton: true,
      extendedTimeOut: 5000,
      progressBar: false,
      tapToDismiss: true,
      preventDuplicates: true,
    }),
    MatDialogModule,
  ],
  providers: [
    AuthorizedGuard,
    AutorizationGuard,
    UtcToLocalPipe,
    provideEnvironmentNgxMask(),
    DatePipe,
    NumToRomanPipe,
    PhonePipe,
    MyDatePipe,
  ],
})
export class CoreModule { }
